import { generateTotalExpression } from 'utilities/generateTotalExpression';
import { GenerateAllRowsExpression, GenerateAllRowsExpressionGenerics } from './types';

const generateAllRowsExpression = <T extends GenerateAllRowsExpressionGenerics>(
  params: GenerateAllRowsExpression<T>
) => {
  const { excludedRows, excludeLastRow = false, rowConfig } = params;

  const totalExcludedRows = excludedRows + 1; // +1 arrayIndex

  const allRows = Array.from(
    { length: rowConfig.length - (excludeLastRow ? totalExcludedRows : excludedRows) },
    () => ({})
  );

  const allRowsExpression = generateTotalExpression({
    items: allRows,
    skippedIndexes: totalExcludedRows,
  });

  return allRowsExpression;
};

export default generateAllRowsExpression;
